import React from "react";
import { Typography, Box } from "@mui/material";

const IntegrityPledge = () => (
    <Box sx={{ padding: '20px' }}>
        <Typography variant="h5" component="h1" gutterBottom>
            Laadu Integrity Pledge
        </Typography>
        <Typography variant="body1" paragraph>
            At Laadu, we believe learning flourishes in a community rooted in trust, respect, and integrity. Our Integrity Pledge outlines the values that keep our platform a fair and supportive place for everyone to grow. By using Laadu, you agree to uphold these principles and our Terms of Service.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            Our Commitment to Integrity
        </Typography>
        <Typography variant="body1" component="ul" sx={{ listStyleType: 'disc', pl: 4 }}>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Learn with honesty:</strong> Use Laadu to enhance your knowledge, not to cheat. Sharing or using test banks, exam questions, or confidential course materials to gain an unfair advantage is not allowed and harms the learning process.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Respect intellectual property:</strong> Only share content you have permission to use. Posting or sharing material that violates someone else's copyright or intellectual property rights is not permitted. Learn more about our DMCA and copyright policy.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Foster a respectful community:</strong> Treat others with kindness and respect. Content or behavior that promotes hatred, discrimination, or harassment based on race, ethnicity, religion, gender, age, sexual orientation, or disability is not allowed on Laadu.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Protect privacy:</strong> Safeguard your own and others' personal information. Do not share personally identifiable details on Laadu. See our privacy policy for more details.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Stay focused on learning:</strong> Create and share content that supports education. Content unrelated to learning, such as social chats, spam, or non-educational material, will be removed.
                </Typography>
            </li>
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
      
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
            Your Role in Our Community
        </Typography>
        <Typography variant="body1" paragraph>
            We rely on our users to uphold this Integrity Pledge and report any content or behavior that violates these principles. If you see something that doesn't align with this pledge, please report it through our Reporting Inappropriate Content page.
        </Typography>
        <Typography variant="body1" paragraph>
            By following this Integrity Pledge, you help make Laadu a vibrant, ethical, and inspiring place to learn. Thank you for being part of our mission to empower education!
        </Typography>
    </Box>
);

export default IntegrityPledge;